import FeeStructureClientPage from "../fee_structure.jsx";

export const metadata = {
  title: "Fee Structure | AISECT Inter College",
  description:
    "Annual fee structure for Intermediate (Class 11 & 12) — Science, Commerce, and Arts streams.",
  openGraph: { title: "Fee Structure | AISECT Inter College" },
};


export default function FeeStructurePage() {
  return <FeeStructureClientPage />;
}
